import EditTagScreen from "../modules/tags/EditTagScreen";

export default function EditTag() {
  return (
    <>
      <EditTagScreen />
    </>
  )
}
